/*------------------------------------------------------------------
Please read!
------------------------------------------------------------------*/

/*
This file is a symlink to the blocks.js file in the app folder,
making changes here affects subsites that are using the blocks.js
*/

/*------------------------------------------------------------------
Import the block scripts
------------------------------------------------------------------*/

// Add the src and a condition required to load the script
window.BlocksLoaded = ScriptLoader({
  './blocks/accordion': document.querySelector('.js-accordion-block'),
  './blocks/projects': document.querySelector('.js-default-projects'),
  './blocks/mosaic': document.querySelector('.js-mosaic'),
  './blocks/tabs': document.querySelector('.js-tabs'),
  './blocks/map': document.querySelector('.js-map'),
  './blocks/default/slider': document.querySelector('.js-default-slider'),
  './blocks/default/business-tree': document.querySelector('.js-default-business-tree'),
  './blocks/default/filtered-accordion': document.querySelector('.js-default-filtered-accordion'),
  './blocks/default/timeline': document.querySelector('.js-default-timeline'),
  './blocks/default/roadmap': document.querySelector('.js-default-roadmap'),
  './blocks/default/product-sheet': document.querySelector('.js-product-sheet'),
  './blocks/gallery/news': document.querySelector('.js-gallery-news')
}, 'blocks-loaded');
window.addEventListener('blocks-loaded', () => {
  console.log("%cblocks", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('blocks-loaded');
});